var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-event-date"},[_c('div',{staticClass:"card-event-date__month"},[_c('span',[_vm._v(_vm._s(_vm.month))])]),_c('div',{staticClass:"card-event-date__day"},[_c('span',[_vm._v(_vm._s(_vm.day))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }